/**
 * Qué ofrece el panel cuando la validación pide una decisión. Vive fuera del componente y es
 * una función pura porque la regla importa: mandar `allowUnordered` sin el pedido devuelve la
 * petición al punto de partida (el servidor ve la factura «sin pedido» y responde otra vez con
 * candidatos), y ofrecer «compra directa» en una factura ya enlazada mete en stock una línea que
 * ya había entrado con el pedido.
 */
export type PanelCode = 'INVOICE_ORDER_CANDIDATES' | 'INVOICE_UNORDERED_LINES';

export interface PanelChoice {
  code: PanelCode;
  purchaseOrderId: string | null;
  candidates: unknown[];
}

export type PanelAction = 'link' | 'confirmUnordered' | 'directPurchase' | 'cancel';

export function panelActions(choice: PanelChoice): PanelAction[] {
  if (choice.code === 'INVOICE_UNORDERED_LINES') {
    // La factura ya está enlazada: solo cabe confirmar que esas líneas no son del pedido.
    return ['confirmUnordered', 'cancel'];
  }
  const actions: PanelAction[] = [];
  if (choice.candidates.length > 0) actions.push('link');
  actions.push('directPurchase', 'cancel');
  return actions;
}

/** Cuerpo que se manda al servidor según la acción elegida. */
export function panelBody(choice: PanelChoice, action: PanelAction) {
  switch (action) {
    case 'confirmUnordered':
      // El pedido tiene que viajar con la confirmación: sin él, el servidor no distingue.
      return { purchaseOrderId: choice.purchaseOrderId ?? undefined, allowUnordered: true };
    case 'directPurchase':
      return { directPurchase: true };
    default:
      return {};
  }
}
